import React from 'react'

const BlogDetail = () => {
  return (
    <div>
      
    </div>
  )
}

export default BlogDetail
